module.exports = __webpack_public_path__ + "/images/shop/icon/catalog/information_systems.svg";